<template>
  <div class="timeline-component">
    <v-timeline align-top dense>
      <v-timeline-item
        v-for="(item, index) in historicoProgresso"
        :key="index"
        color="transparent"
        fill-dot
        icon="fas fa-diamond"
        icon-color="primary"
      >
        <template #default>
          <h2 class="titulo-secao">{{ item.data }}</h2>
          <div class="timeline-card">
            <b>
              {{ item.pessoa }}
              <span v-if="item.objetivo">
                | Objetivo:
                <span class="black--text">{{ item.objetivo }}</span>
              </span>
              <span v-if="item.prazo">
                | Prazo:
                <span class="black--text">{{ item.prazo }}</span>
              </span>
            </b>
            <br />
            <span>{{ item.comentario }}</span>
          </div>
        </template>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
export default {
  name: 'TimelinePdi',
  props: {
    historicoProgresso: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.timeline-card {
  padding: 0 1rem;
  margin: 1rem 0 0 0.25rem;
  border-left: 4px solid #278b97;
  border-radius: 4px !important;
  box-shadow: none !important;
}

.timeline-card b {
  font-size: 1rem;
  font-weight: 700;
  color: #278b97 !important;
}

.timeline-card::before,
.timeline-card::after {
  display: none;
}
</style>
